import { Component, OnInit } from '@angular/core';
import { delay, map, take, tap } from 'rxjs/operators';
import { AuthService, EnvironmentConfigurationService, User } from './scip/services';
import { environment } from '../environments/environment';
import { Router } from '@angular/router';
import { routes } from './app.routes';
import { translationKeys } from './scip/core';
import { AppheaderUserInfo } from '@avano/avano-components/avano-appheader';
import { Observable } from 'rxjs';

@Component({
  selector: 'scip-topbar',
  templateUrl: './scip.topbar.component.html',
  styleUrls: ['./scip.topbar.component.scss']
})
export class ScipTopBarComponent implements OnInit {
  user$: Observable<AppheaderUserInfo>;
  username: string;
  userOrganization: string;
  systemRibbonText: string;

  showDashboardConfig = false; // Temporary check if dashboard is even enabled
  showDashboardDialog = false;

  translationKeys: typeof translationKeys = translationKeys;

  constructor(private authService: AuthService, private router: Router, private envService: EnvironmentConfigurationService) {}

  ngOnInit(): void {
    this.initializeUserInfo();
    this.initializeSystemRibbon();
    this.showDashboardConfig = !this.envService.environment.dashboardHidden;
  }

  logout(): void {
    this.router.navigate([routes.logout]);
  }

  private initializeUserInfo() {
    this.user$ = this.authService.getUser$().pipe(
      tap((currentUser: User) => {
        this.username = currentUser.full_name;
        this.userOrganization = currentUser.org_name;
      }),
      delay(1), // Needed because we use that observable together with a condition which is triggered by a children
      map((currentUser: User) => {
        return {
          email: currentUser.email,
          fullName: currentUser.full_name,
          role: '' // We currently do not show the roles in the ui, but this would be a/the place for it
        };
      }),
      take(1) // Currently, the user does not get changed during a session, therefore we just take it once
    );
  }

  private initializeSystemRibbon(): void {
    // Locally we use the default angular environment-mechanism to identify a local build
    if (environment?.systemRibbon?.length) {
      this.systemRibbonText = environment.systemRibbon;
    }

    // On deployed versions we use the variable from loadEnvironment
    // could be e.g. "QA SYSTEM" or "TEST SYSTEM" or ...
    if (this.envService.environment.systemRibbon) {
      this.systemRibbonText = this.envService.environment.systemRibbon;
    }
  }
}
